import { render } from "./TimelinePage.vue?vue&type=template&id=2570adaa&ts=true"
import script from "./TimelinePage.vue?vue&type=script&lang=ts"
export * from "./TimelinePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__